import React from 'react';
import InternetExplorer from './InternetExplorer';
import ErrorBox from './ErrorBox';
import MyComputer from './MyComputer';
import Notepad from './Notepad';
import Paint from './Paint';
import Bluesky from './Bluesky';
import MyArt from './MyArt';
import Lottel from './Lottel';
import Twitch from './Twitch';
import Discord from './Discord';
import ImageFolder from './ImageFolder';
import Login from './Login';
import Profile from './Profile';
import MyNotes from './MyNotes';
import MyFolder from './MyFolder';
import Members from './Members';
import Admin from './Admin';
import Mail from './Mail';
import Mystery from './Mystery';
import iePaper from 'assets/windowsIcons/ie-paper.png';
import error from 'assets/windowsIcons/897(16x16).png';
import computer from 'assets/windowsIcons/676(16x16).png';
import notepad from 'assets/windowsIcons/327(16x16).png';
import notepadLarge from 'assets/windowsIcons/327(32x32).png';
import paint from 'assets/windowsIcons/680(16x16).png';
import bskyLogo from 'assets/windowsIcons/bluesky.svg';
import myArtIcon from 'assets/windowsIcons/307(32x32).png';
import folderLarge from 'assets/windowsIcons/318(48x48).png';
import folderSmallIcon from 'assets/windowsIcons/318(16x16).png';
import twitchIcon from 'assets/windowsIcons/twitch.svg';
import discordIcon from 'assets/windowsIcons/discord.ico';
import userIconSmall from 'assets/windowsIcons/user.png';
import mailIconSmall from 'assets/windowsIcons/887(16x16).png';
import mailIconLarge from 'assets/windowsIcons/887(32x32).png';
import adminIconSmall from 'assets/windowsIcons/227(16x16).png';
import adminIconLarge from 'assets/windowsIcons/227(32x32).png';

const tinyclownIcon = '/tinyclown.gif';

// Create wrapped components for identity checks by the Window Manager
const MyArtApp = props => <ImageFolder {...props} />;
const CatPhotosApp = props => <ImageFolder {...props} />;

const gen = () => {
  let id = -1;
  return () => {
    id += 1;
    return id;
  };
};
const genId = gen();
const genIndex = gen();

export const defaultAppState = [
  {
    component: Bluesky,
    header: {
      title: `Bluesky \u2014 @lottel.bsky.social`,
      icon: bskyLogo,
    },
    defaultSize: {
      width: 390,
      height: 780,
    },
    defaultOffset: {
      x: Math.max(120, window.innerWidth - 420),
      y: 20,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 430,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Lottel,
    header: {
      title: 'Lottel',
      icon: folderSmallIcon,
    },
    defaultSize: {
      width: 680,
      height: 480,
    },
    defaultOffset: {
      x: 140,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 780,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Notepad,
    header: {
      title: 'About Me.txt - Notepad',
      icon: notepad,
    },
    defaultSize: {
      width: 460,
      height: 340,
    },
    defaultOffset: {
      x: 240,
      y: 260,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 540,
    injectProps: { src: './about-me.txt' },
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Notepad,
    header: {
      title: 'BLOG.txt - Notepad',
      icon: notepad,
    },
    defaultSize: {
      width: 500,
      height: 440,
    },
    defaultOffset: {
      x: 300,
      y: 100,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 540,
    injectProps: { src: './blog.txt' },
    id: genId(),
    zIndex: genIndex(),
  },
];

export const defaultIconState = [
  {
    id: 0,
    icon: folderLarge,
    title: 'Lottel',
    component: Lottel,
    isFocus: false,
  },
  {
    id: 1,
    icon: myArtIcon,
    title: 'My Art',
    component: MyArtApp,
    isFocus: false,
  },
  {
    id: 2,
    icon: folderLarge,
    title: 'Cat Photos',
    component: CatPhotosApp,
    isFocus: false,
  },
  {
    id: 3,
    icon: bskyLogo,
    title: 'Bluesky',
    component: Bluesky,
    isFocus: false,
  },
  {
    id: 4,
    icon: twitchIcon,
    title: 'Twitch',
    component: Twitch,
    isFocus: false,
  },
  {
    id: 5,
    icon: discordIcon,
    title: 'Discord',
    component: Discord,
    isFocus: false,
  },
  {
    id: 6,
    icon: notepadLarge,
    iconSize: 32,
    title: 'BLOG.txt',
    component: Notepad,
    isFocus: false,
  },
  {
    id: 7,
    icon: mailIconLarge,
    title: 'Mail',
    component: Mail,
    isFocus: false,
    adminOnly: true,
  },
  {
    id: 8,
    icon: adminIconLarge,
    title: 'Admin',
    component: Admin,
    isFocus: false,
    adminOnly: true,
  },
  {
    id: 9,
    icon: tinyclownIcon,
    title: '???',
    component: Mystery,
    isFocus: false,
    inert: true,
    iconSize: 64,
    pixelated: true,
  },
];

export const appSettings = {
  'Internet Explorer': {
    header: {
      icon: iePaper,
      title: 'InternetExplorer',
    },
    component: InternetExplorer,
    defaultSize: {
      width: 700,
      height: 500,
    },
    defaultOffset: {
      x: 140,
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Error: {
    header: {
      icon: error,
      title: 'C:\\',
      buttons: ['close'],
      noFooterWindow: true,
    },
    component: ErrorBox,
    defaultSize: {
      width: 380,
      height: 0,
    },
    defaultOffset: {
      x: window.innerWidth / 2 - 190,
      y: window.innerHeight / 2 - 60,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  'My Computer': {
    header: {
      icon: computer,
      title: 'My Computer',
    },
    component: MyComputer,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 260,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Notepad: {
    header: {
      icon: notepad,
      title: 'Untitled - Notepad',
    },
    component: Notepad,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 270,
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Paint: {
    header: {
      icon: paint,
      title: 'Untitled - Paint',
    },
    component: Paint,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Bluesky: {
    header: {
      icon: bskyLogo,
      title: `Bluesky \u2014 @lottel.bsky.social`,
    },
    component: Bluesky,
    defaultSize: {
      width: 400,
      height: 740,
    },
    defaultOffset: {
      x: Math.max(20, window.innerWidth - 440),
      y: 20,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 440,
    multiInstance: false,
  },
  'My Art': {
    header: {
      icon: myArtIcon,
      title: 'My Art',
    },
    component: MyArtApp,
    injectProps: { folderKey: 'my-art', title: 'My Art' },
    defaultSize: {
      width: 720,
      height: 520,
    },
    defaultOffset: {
      x: 180,
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 780,
    multiInstance: false,
  },
  'Cat Photos': {
    header: {
      icon: folderSmallIcon,
      title: 'Cat Photos',
    },
    component: CatPhotosApp,
    injectProps: { folderKey: 'cat-photos', title: 'Cat Photos' },
    defaultSize: {
      width: 720,
      height: 520,
    },
    defaultOffset: {
      x: 200,
      y: 80,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 780,
    multiInstance: false,
  },
  Lottel: {
    header: {
      icon: folderSmallIcon,
      title: 'Lottel',
    },
    component: Lottel,
    defaultSize: {
      width: 720,
      height: 520,
    },
    defaultOffset: {
      x: 120,
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 780,
    multiInstance: false,
  },
  'About Me': {
    header: {
      icon: notepad,
      title: 'About Me.txt - Notepad',
    },
    component: Notepad,
    defaultSize: {
      width: 460,
      height: 340,
    },
    defaultOffset: {
      x: 240,
      y: 260,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 540,
    multiInstance: false,
    injectProps: { src: './about-me.txt' },
  },
  'BLOG.txt': {
    header: {
      icon: notepad,
      title: 'BLOG.txt - Notepad',
    },
    component: Notepad,
    defaultSize: {
      width: 500,
      height: 440,
    },
    defaultOffset: {
      x: 300,
      y: 100,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 540,
    multiInstance: false,
    injectProps: { src: './blog.txt' },
  },
  'Log On': {
    header: {
      icon: userIconSmall,
      title: 'Log On to lottel.fun',
      buttons: ['close'],
    },
    component: Login,
    defaultSize: {
      width: 420,
      height: 340,
    },
    defaultOffset: {
      x: Math.max(20, window.innerWidth / 2 - 210),
      y: Math.max(20, window.innerHeight / 2 - 190),
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Profile: {
    header: {
      icon: userIconSmall,
      title: 'My Profile',
      buttons: ['close'],
    },
    component: Profile,
    defaultSize: {
      width: 480,
      height: 460,
    },
    defaultOffset: {
      x: Math.max(20, window.innerWidth / 2 - 240),
      y: Math.max(20, window.innerHeight / 2 - 250),
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 520,
    multiInstance: false,
  },
  'My Notes': {
    header: {
      icon: notepad,
      title: 'My Notes',
      buttons: ['close'],
    },
    component: MyNotes,
    defaultSize: {
      width: 520,
      height: 420,
    },
    defaultOffset: {
      x: Math.max(20, window.innerWidth / 2 - 260),
      y: Math.max(20, window.innerHeight / 2 - 230),
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 560,
    multiInstance: false,
  },
  'My Folder': {
    header: {
      icon: folderSmallIcon,
      title: 'My Folder',
      buttons: ['close'],
    },
    component: MyFolder,
    defaultSize: {
      width: 720,
      height: 500,
    },
    defaultOffset: {
      x: Math.max(20, window.innerWidth / 2 - 360),
      y: Math.max(20, window.innerHeight / 2 - 270),
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 780,
    multiInstance: false,
  },
  Members: {
    header: {
      icon: folderSmallIcon,
      title: 'Members',
      buttons: ['close'],
    },
    component: Members,
    defaultSize: {
      width: 620,
      height: 460,
    },
    defaultOffset: {
      x: Math.max(20, window.innerWidth / 2 - 310),
      y: Math.max(20, window.innerHeight / 2 - 250),
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 680,
    multiInstance: false,
  },
  Admin: {
    header: {
      icon: adminIconSmall,
      title: 'Admin',
      buttons: ['close', 'maximize', 'minimize'],
    },
    component: Admin,
    defaultSize: {
      width: 720,
      height: 540,
    },
    defaultOffset: {
      x: Math.max(20, window.innerWidth / 2 - 360),
      y: Math.max(20, window.innerHeight / 2 - 290),
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 780,
    multiInstance: false,
  },
  Mail: {
    header: {
      icon: mailIconSmall,
      title: 'Mail',
      buttons: ['close'],
    },
    component: Mail,
    defaultSize: { width: 320, height: 160 },
    defaultOffset: { x: 200, y: 200 },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  '???': {
    header: {
      icon: tinyclownIcon,
      title: '???',
      buttons: ['close'],
    },
    component: Mystery,
    defaultSize: { width: 260, height: 240 },
    defaultOffset: {
      x: Math.max(20, window.innerWidth / 2 - 130),
      y: Math.max(20, window.innerHeight / 2 - 120),
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
};

export {
  InternetExplorer,
  ErrorBox,
  MyComputer,
  Notepad,
  Bluesky,
  MyArt,
  Lottel,
};
